import { orders } from './resources/orders'
import { containers } from './resources/containers'
import { shipments } from './resources/shipments'
import { customers } from './resources/customers'
import { users } from './resources/users'
import { publicContainer } from './resources/publicContainer'
import { settings } from './resources/settings'
import { products } from './resources/products'
import { companies } from './resources/companies'
import { certificates } from './resources/certificates'
import { customsDeclarations } from './resources/customsDeclarations'
import { declaredProducts } from './resources/declaredProducts'
import { conditionalItems } from './resources/conditionalItems'
import { audits } from './resources/audits'
import { expenseItems } from './resources/expenseItems'
import { issueVouchers } from './resources/issueVouchers'
import { congNo } from './resources/congNo'
import { tonKho } from './resources/tonKho'
import { thongBao } from './resources/thongBao'
import { giaVon } from './resources/giaVon'
import { nhomHang } from './resources/nhomHang'
import { nhomKhachHang } from './resources/nhomKhachHang'
import { khachHang } from './resources/khachHang'
import { nhaCungCap } from './resources/nhaCungCap'
import { bangGia } from './resources/bangGia'
import { diaChiNhanHang } from './resources/diaChiNhanHang'
import { thongTinXuatHoaDon } from './resources/thongTinXuatHoaDon'
import { phieuNhapKho } from './resources/phieuNhapKho'
import { phieuXuatKho } from './resources/phieuXuatKho'
import { datHang } from './resources/datHang'
import { testDataMenuI18n } from '@/modules/test-data/i18n/vi'
import { uiTestMenuI18n } from '@/modules/ui-test/i18n/vi'
import { testModuleChiTietMenuI18n } from '@/modules/test-module-chitiet/i18n/vi'
import { hoaDon } from './resources/hoaDon'
import { kenhBan } from './resources/kenhBan'
import { datHangNcc } from './resources/datHangNcc'
import { phieuNhanHang } from './resources/phieuNhanHang'
import { traHang } from './resources/traHang'
import { yeuCauSuaChua } from './resources/yeuCauSuaChua'
import { kiemKe } from './resources/kiemKe'
import { danhMucThuKhac } from './resources/danhMucThuKhac'
import { donViTinh } from './resources/donViTinh'
import { thuongHieu } from './resources/thuongHieu'
import { phanLoaiSanPham } from './resources/phanLoaiSanPham'
import { thongTinVatHangHoa } from './resources/thongTinVatHangHoa'
import { thuocTinh } from './resources/thuocTinh'
import { viTri } from './resources/viTri'
import { diaChiLayHang } from './resources/diaChiLayHang'
import { chuyenHang } from './resources/chuyenHang'
import { soQuy } from './resources/soQuy'
import { taiKhoanQuy } from './resources/taiKhoanQuy'
import { mauIn } from './resources/mauIn'
import { yeuCauXuatHoaDon } from './resources/yeuCauXuatHoaDon'
import { baoCao } from './resources/baoCao'
import { vanHanh } from './resources/vanHanh'
import { loTrinh } from './resources/loTrinh'
import { common } from './common'

export const vi = {
  common, // UI elements, actions, status
  // auth, // Login, logout, password reset
  // navigation,         // Menu, breadcrumbs
  resources: {
    // Your business entities
    orders,
    containers,
    users,
    shipments,
    customers,
    publicContainer,
    settings,
    products,
    companies,
    certificates,
    customsDeclarations,
    declaredProducts,
    conditionalItems,
    audits,
    expenseItems,
    issueVouchers,
    congNo,
    tonKho,
    thongBao,
    giaVon,
    nhomHang,
    nhomKhachHang,
    khachHang,
    nhaCungCap,
    bangGia,
    diaChiNhanHang,
    thongTinXuatHoaDon,
    phieuNhapKho,
    phieuXuatKho,
    datHang,
    hoaDon,
    kenhBan,
    datHangNcc,
    phieuNhanHang,
    traHang,
    yeuCauSuaChua,
    kiemKe,
    danhMucThuKhac,
    donViTinh,
    thuongHieu,
    phanLoaiSanPham,
    thongTinVatHangHoa,
    thuocTinh,
    viTri,
    diaChiLayHang,
    chuyenHang,
    soQuy,
    taiKhoanQuy,
    mauIn,
    yeuCauXuatHoaDon,
    baoCao,
    vanHanh,
    loTrinh,
  },
  pages: {
    // Page-specific content
    dashboard: {
      title: 'Tổng quan kinh doanh',
      subtitle: 'Hôm nay, {date}',
      recentOrders: 'Đơn đặt hàng gần đây',
      recentInvoices: 'Hóa đơn gần đây',
      monthLabel: 'Tháng {month}/{year}',
      ky: {
        loai: {
          NGAY: 'Ngày',
          TUAN: 'Tuần',
          THANG: 'Tháng',
          QUY: 'Quý',
          NAM: 'Năm',
        },
        ngayLabel: '{day}/{month}/{year}',
        tuanLabel: 'Tuần {tuan}/{year} ({range})',
        thangLabel: 'Tháng {month}/{year}',
        quyLabel: 'Quý {quy}/{year}',
        namLabel: 'Năm {year}',
      },
      actions: {
        sell: 'Bán hàng',
        reports: 'Báo cáo',
        viewAll: 'Xem tất cả',
      },
      kpi: {
        revenue: 'Doanh thu',
        paid: 'Đã thu',
        invoiceCount: 'Số hóa đơn',
        avgInvoice: 'Giá trị TB / hóa đơn',
        vsPrevPeriod: 'so với cùng kỳ trước',
        noPrevData: 'Cùng kỳ trước ({range}) chưa có dữ liệu',
        today: 'Hôm nay: {value}',
        perDay: 'TB/ngày có bán: {value}',
        unpaid: 'Còn phải thu: {value}',
        paidRate: 'Tỷ lệ thu {value}%',
        prevPeriodHint: 'Kỳ trước: {value}',
      },
      chart: {
        title: 'Doanh thu theo ngày',
        titleOnDay: 'Doanh thu trong ngày',
        titleInMonth: 'Doanh thu trong tháng',
        titleByMonth: 'Doanh thu theo tháng',
        revenue: 'Doanh thu',
        invoiceCount: 'Số hóa đơn',
        dayLabel: 'Ngày {day}',
        monthLabel: 'Tháng {month}',
        empty: 'Chưa phát sinh hóa đơn trong kỳ này',
      },
      dtBang: {
        nvkdTitle: 'Doanh thu × Nhân viên kinh doanh',
        chiNhanhTitle: 'Doanh thu × Chi nhánh',
        empty: 'Chưa phát sinh doanh thu trong kỳ này',
        loadFailed: 'Không tải được bảng doanh thu.',
        tongCong: 'Tổng cộng',
        cols: {
          nvkd: 'NVKD',
          chiNhanh: 'Chi nhánh',
          sl: 'SL',
          dtThuan: 'DT thuần',
          giaVon: 'Giá vốn',
          loiNhuan: 'Lợi nhuận',
          lnTrenVon: '% LN/giá vốn',
          margin: '% Margin LN/doanh thu',
          soKg: 'Số kg',
          soKhoi: 'Số khối',
          tyTrong: 'Tỷ trọng',
        },
      },
      topSale: {
        title: 'Top sale',
        empty: 'Chưa có sản phẩm bán trong kỳ này',
        loadFailed: 'Không tải được top sale.',
        soTopValue: 'Top {n}',
        tieuChi: {
          DOANH_THU: 'Doanh thu',
          SO_LUONG: 'SL',
          LOI_NHUAN: 'Lợi nhuận',
        },
        cols: {
          ma: 'Mã hàng',
          ten: 'Tên hàng',
          sl: 'SL',
          giaVon: 'Giá vốn',
          loiNhuan: 'Lợi nhuận',
          lnTrenVon: '% LN/giá vốn',
          margin: '% Margin LN/doanh thu',
          soKg: 'Số kg',
          soKhoi: 'Số khối',
          tyTrong: 'Thị phần',
          metric: {
            DOANH_THU: 'DT thuần',
            SO_LUONG: 'SL bán',
            LOI_NHUAN: 'Lợi nhuận',
          },
        },
      },
      topMua: {
        title: 'Top mua',
        empty: 'Chưa có khách mua trong kỳ này',
        loadFailed: 'Không tải được top mua.',
        soTopValue: 'Top {n}',
        tieuChi: {
          DOANH_THU: 'Doanh thu',
          SO_LUONG: 'SL',
          LOI_NHUAN: 'Lợi nhuận',
        },
        cols: {
          ma: 'Mã khách',
          ten: 'Tên khách',
          nvkd: 'NVKD phụ trách',
          soHd: 'Số HĐ',
          sl: 'SL',
          giaVon: 'Giá vốn',
          loiNhuan: 'Lợi nhuận',
          lnTrenVon: '% LN/giá vốn',
          margin: '% Margin LN/doanh thu',
          soKg: 'Số kg',
          soKhoi: 'Số khối',
          tyTrong: 'Thị phần',
          metric: {
            DOANH_THU: 'DT thuần',
            SO_LUONG: 'SL mua',
            LOI_NHUAN: 'Lợi nhuận',
          },
        },
      },
      overview: {
        title: 'Dữ liệu hệ thống',
        subtitle: 'Số liệu lũy kế theo chi nhánh đang chọn',
      },
      columns: {
        code: 'Mã phiếu',
        customer: 'Khách hàng',
        total: 'Tổng tiền',
        status: 'Trạng thái',
        time: 'Thời gian',
      },
      stats: {
        products: 'Hàng hóa',
        stock: 'Tồn kho: {count}',
        customers: 'Khách hàng',
        suppliers: 'Nhà cung cấp',
        orders: 'Đơn hàng',
        invoices: 'Hóa đơn',
        returns: 'Trả hàng',
        goodsReceipts: 'Phiếu nhập hàng',
        stocktakes: 'Kiểm kê',
        inventoryValue: 'Giá vốn tồn',
      },
      salesReport: {
        title: 'Báo cáo doanh thu',
        invoiceCount: 'Số hóa đơn',
        revenue: 'Doanh thu',
        date: 'Ngày',
      },
    },
    pos: {
      title: 'Bán hàng POS',
      searchPlaceholder: 'Tìm mã / tên hàng hóa...',
      cart: 'Giỏ hàng',
      items: 'món',
      stock: 'Tồn',
      subtotal: 'Tạm tính',
      checkout: 'Thanh toán',
      payment: 'Thanh toán',
      paymentMethod: 'Phương thức',
      customerPaid: 'Khách đưa',
      change: 'Tiền thừa',
      confirmPay: 'Xác nhận thanh toán',
      emptyCart: 'Giỏ hàng trống',
      emptyCartHint: 'Chọn sản phẩm bên trái hoặc quét mã',
      checkoutSuccess: 'Thanh toán thành công',
      productNotFound: 'Không tìm thấy hàng hóa',
      productInactive: 'Hàng đã ngừng kinh doanh',
      addedToCart: 'Đã thêm {name}',
      invalidPayment: 'Số tiền thanh toán không hợp lệ',
      scanBarcode: 'Quét mã vạch',
      scannerError: 'Không mở được camera. Kiểm tra quyền truy cập.',
      methods: {
        TIEN_MAT: 'Tiền mặt',
        THE: 'Thẻ',
        VI: 'Ví',
        CHUYEN_KHOAN: 'Chuyển khoản',
      },
    },
    profile: {
      title: 'Tài khoản của tôi',
      subtitle: 'Xem và cập nhật thông tin hồ sơ cá nhân',
      editSection: 'Chỉnh sửa thông tin',
    },
    settings: {},
  },
  components: {
    menu: {
      home: 'Trang chủ',
      productsSection: 'Hàng hóa',
      productMenuCatalog: 'Danh mục',
      productMenuSetup: 'Thiết lập',
      dataSection: 'Dữ liệu',
      products: 'Sản phẩm',
      phanLoaiSanPhamList: 'Phân loại sản phẩm',
      thongTinVatHangHoaList: 'Thông tin VAT hàng hóa',
      sanPhamKhaiBao: 'SP khai báo',
      transport: 'Vận chuyển',
      productCategories: 'Danh mục',
      priceGroups: 'Nhóm giá',
      declarationGroups: 'Công bố',
      operations: 'Nghiệp vụ',
      orders: 'Đơn hàng',
      shipments: 'Lô hàng',
      customers: 'Khách hàng',
      system: 'Hệ thống',
      warehouses: 'Kho',
      containers: 'Container',
      expenseItems: 'DM chi phí',
      inventory: 'Kho hàng',
      phieuXuat: 'Phiếu xuất',
      tonKho: 'Tồn kho',
      congNo: 'Công nợ',
      congNoKhachHang: 'Công nợ khách hàng',
      congNoThanhToan: 'Thanh toán',
      congNoHoanTien: 'Hoàn tiền',
      congNoTheoDon: 'Công nợ theo đơn',
      congNoTheoDonChiTiet: 'Công nợ theo đơn chi tiết',
      giaVon: 'Giá vốn',
      staffs: 'Nhân viên',
      scanner: 'Quét mã',
      settings: 'Cài đặt',
      companies: 'Công ty',
      certificates: 'Chứng nhận',
      customsDeclarations: 'Tờ khai HQ',
      conditionalItems: 'Điều kiện',
      auditLogs: 'Nhật ký',
      branchProject: 'Chi nhánh',
      switchBranch: 'Đổi chi nhánh',
      nhomHangList: 'Nhóm hàng',
      partnersSection: 'Đối tác',
      customersSection: 'Khách hàng',
      nhomKhachHangList: 'Nhóm khách hàng',
      khachHangList: 'Khách hàng',
      diaChiNhanHangList: 'Thông tin giao hàng',
      thongTinXuatHoaDonList: 'Thông tin xuất hóa đơn',
      suppliersSection: 'Nhà cung cấp',
      nhaCungCapList: 'Danh sách NCC',
      deliverySection: 'Giao hàng',
      doiTacGiaoHangList: 'Đối tác giao hàng',
      bangGiaList: 'Thiết lập bảng giá',
      bangGiaHangHoaList: 'Bảng giá hàng hóa',
      phieuNhapKhoList: 'Nhập kho',
      phieuXuatKhoList: 'Xuất kho',
      dashboard: 'Tổng quan',
      salesSection: 'Đơn hàng',
      banOnline: 'Bán online',
      donHangOnlineList: 'Đơn hàng online',
      donHangOnlineTiktok: 'Đơn TikTok Shop',
      donHangOnlineShopee: 'Đơn Shopee',
      hangHoaLienKetList: 'Hàng hóa liên kết',
      doiSoatOnlineList: 'Đối soát',
      gianHangOnlineList: 'Gian hàng',
      thietLapKenhOnline: 'Thiết lập kênh',
      datHangList: 'Đặt hàng',
      hoaDonList: 'Hóa đơn',
      maVanDonList: 'Mã vận đơn',
      hoaDonChiTietList: 'Hóa đơn chi tiết',
      yeuCauXuatHoaDonList: 'Yêu cầu xuất hóa đơn',
      xuatHuyList: 'Xuất hủy',
      xuatTraNccList: 'Xuất trả NCC',
      banHang: 'Bán hàng',
      phanQuyen: 'Phân quyền',
      muaHang: 'Mua hàng',
      sanXuat: 'Sản xuất',
      pos: 'Bán hàng POS',
      traHangList: 'Trả hàng',
      datHangNccList: 'Đặt hàng NCC',
      phieuNhanHangList: 'Phiếu nhận hàng',
      yeuCauSuaChuaList: 'Yêu cầu sửa chữa',
      kiemKeList: 'Kiểm kê',
      auditList: 'Nhật ký thao tác',
      logLoiHeThong: 'Log lỗi hệ thống (DEV)',
      danhMucThuKhacList: 'Danh mục thu khác',
      donViTinhList: 'Đơn vị tính',
      thuongHieuList: 'Thương hiệu',
      thuocTinhList: 'Thuộc tính hàng hóa',
      viTriList: 'Vị trí kho',
      diaChiLayHangList: 'Địa chỉ lấy hàng',
      chuyenHangList: 'Chuyển hàng',
      inventorySection: 'Kho hàng',
      congQuyGroup: 'Công quỹ',
      soQuyGroup: 'Sổ quỹ',
      soQuyPhieuThu: 'Phiếu thu',
      soQuyPhieuChi: 'Phiếu chi',
      soQuyBaoCao: 'Báo cáo',
      soQuyTaiKhoanQuy: 'Quản lý tài khoản quỹ',
      soQuyLoaiThuChi: 'Loại thu chi',
      baoCaoSection: 'Báo cáo',
      baoCaoBanHangGroup: 'Bán hàng',
      baoCaoKhoGroup: 'Kho',
      baoCaoTongHop: 'Tổng hợp',
      baoCaoCuoiNgay: 'Cuối ngày',
      baoCaoBanHang: 'Bán hàng',
      baoCaoDatHang: 'Đặt hàng',
      baoCaoHangHoa: 'Hàng hóa',
      baoCaoKhachHang: 'Khách hàng',
      baoCaoNhaCungCap: 'Nhà cung cấp',
      baoCaoNhanVien: 'Nhân viên',
      baoCaoKenhBan: 'Kênh bán hàng',
      baoCaoTaiChinh: 'Tài chính',
      baoCaoPhanTich: 'Phân tích',
      baoCaoDoanhThuLn: 'Doanh thu, lợi nhuận',
      baoCaoTonKho: 'Tồn kho',
      baoCaoTopSale: 'Top sale',
      baoCaoTopMua: 'Top mua',
      baoCaoDaLuu: 'Báo cáo đã lưu',
      vanHanhSection: 'Kho',
      vanHanhDonHang: 'Tất cả đơn hàng',
      vanHanhXepNhat: 'Xếp nhặt',
      vanHanhKiemTra: 'Kiểm tra',
      vanHanhDongGoi: 'Đóng gói',
      vanHanhDieuPhoi: 'Điều phối',
      vanHanhGiaoHang: 'Giao hàng',
      banDoGiaoHang: 'Bản đồ giao hàng',
      thongBaoTrungTam: 'Trung tâm thông báo',
      caiDatThongBao: 'Cài đặt thông báo',
      mauInHoaDon: 'Mẫu in',
      uiKit: 'Base UI',
      // ===== impl-b =====
      baoCaoChiTietDonHang: 'Chi tiết đơn hàng',
      baoCaoDonVanHanh: 'Theo đơn (workflow)',
      ...testDataMenuI18n,
      ...uiTestMenuI18n,
      ...testModuleChiTietMenuI18n,
    },
    phieuTamTonKho: {
      headerLabel: 'Phiếu tạm',
      headerLabelWithCount: 'Phiếu tạm ({count})',
      headerAria: 'Còn {count} phiếu tạm chưa hoàn thành — bấm để xem danh sách',
      panelTitle: 'Còn {count} phiếu tạm chưa hoàn thành',
      panelHint: 'Hãy hoàn thành phiếu để trừ tồn kho đúng. Click mã để mở chi tiết.',
      viewAll: 'Xem tất cả',
      andMore: '… và {count} phiếu khác',
      createWarnTitle: 'Còn phiếu kiểm kê tạm',
      createWarnBody:
        'Đang còn phiếu kiểm kê ở trạng thái tạm. Nên hoàn thành (trừ tồn) trước khi tạo phiếu mới.',
      createWarnTitleChuyenHang: 'Còn phiếu chuyển hàng tạm',
      createWarnBodyChuyenHang:
        'Đang còn phiếu chuyển hàng ở trạng thái tạm. Nên hoàn thành (trừ tồn) trước khi tạo phiếu mới.',
      createWarnTitleNhapKho: 'Còn phiếu nhập kho tạm',
      createWarnBodyNhapKho:
        'Đang còn phiếu nhập kho ở trạng thái tạm. Nên hoàn thành (cộng tồn) trước khi tạo phiếu mới.',
      createWarnTitleXuatKho: 'Còn phiếu xuất kho tạm',
      createWarnBodyXuatKho:
        'Đang còn phiếu xuất kho ở trạng thái tạm. Nên hoàn thành (trừ tồn) trước khi tạo phiếu mới.',
      createWarnContinue: 'Vẫn tạo mới',
      createWarnCodesLabel: 'Các phiếu tạm:',
      inModalCount: 'còn {count} phiếu',
      chromeHint: 'Còn {count} phiếu tạm',
      createWarnHeaderHint:
        'Danh sách phiếu tạm cũng luôn hiện trên nút «Phiếu tạm» ở thanh header — nhớ hoàn thành để trừ/cộng tồn đúng.',
    },
  },
  auth: {
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    register: 'Đăng ký',
    username: 'Tên người dùng',
    password: 'Mật khẩu',
    confirmPassword: 'Xác nhận mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    resetPassword: 'Đặt lại mật khẩu',
    changePassword: 'Đổi mật khẩu',
    email: 'Email',
    rememberMe: 'Nhớ tôi',
  },
  navigation: {
    home: 'Trang chủ',
    orders: 'Đơn hàng',
    shipments: 'Lô hàng',
    customers: 'Khách hàng',
    warehouses: 'Kho hàng',
    containers: 'Containers',
    staffs: 'Nhân viên',
    settings: 'Cài đặt',
  },
  validation: {
    required: 'Trường này là bắt buộc',
    email: 'Định dạng email không hợp lệ',
    minLength: 'Tối thiểu {min} ký tự',
    maxLength: 'Tối đa {max} ký tự',
    numeric: 'Chỉ cho phép số',
  },
  messages: {
    success: 'Thành công',
    error: 'Đã xảy ra lỗi',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu',
    confirmDelete: 'Bạn có chắc chắn muốn xóa mục này?',
  },
}
